import { Avatar, Box, Button, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { usePasswordResetStyles } from '../PasswordResetStyles';
import { MadeWithLove } from './ResetPasswordContainer';

const ResetPasswordSuccess = () => {
    const classes = usePasswordResetStyles();

    return (
        <Box className={classes.paper}>
            <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Password Set
            </Typography>
            <Typography variant="body2" className={classes.passwordInstructions}>
                Your password has been set successfully, you can now login.
            </Typography>
            <Box mt={3}>
                <Button
                    variant="contained"
                    color="primary"
                    href="/"
                    size="large"
                    style={{ marginTop: '40px' }}
                >
                    Login
                </Button>
            </Box>
            <Box mt={5}>
                <MadeWithLove />
            </Box>
        </Box>
    );
};

export default ResetPasswordSuccess;
